/**
 * userhub has a single environment. The dev server (and the daemon's test env) calls the
 * same-origin `/userhub/api`, which vite.config.ts proxies to `USERHUB_URL`: a local userhub API
 * (`npm run start -w api` in the userhub repo, port 7073) by default, the deployed one in the SSO +
 * prod-data test env. Every build (web and desktop) talks to the deployed one directly. Without a
 * reachable API Niobe works normally — only the feedback dialogs show a load error.
 */
export const USERHUB_API_BASE_URL = import.meta.env.DEV
  ? '/userhub/api'
  : 'https://func-feedback-tlzthr.azurewebsites.net/api'

/** userhub verifies the token with Graph `GET /me`: `User.Read` is all it needs. */
export const USERHUB_SCOPES = ['User.Read']

/** The token under stub auth (no Entra configured). The local API runs in `dev-bypass` there and ignores it. */
export const USERHUB_DEV_TOKEN = 'dev-stub'
